var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.667 26.668 50 40.002 36.667 53.335",
    fill: "#009DF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.667 26.668 50 40.002 36.667 53.335V26.668Z",
    stroke: "#0098EB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgPlay;